<template>
  <div>
    <div class="container article-box">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="coming-soon-title">Coming <span>Soon</span></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <img :src="require('@/assets/images/coming-soon.svg')" alt="icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  

  export default {
    name: 'ComingSoon',
    data () {
      return {
        popularSubclasses: [],
        mainClasses: []
      }
    },
    components: {
      
    },
    created () {
      const self = this;
      self.getProductsData();
    },
    methods: {
      async getProductsData() {
        const self = this;
        const promises = [];
        self.showLoader = true;

        promises.push(await axios.get('get_popular_subclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.popularSubclasses = resp.data.data.subclasses;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return Promise.reject(resp);
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return Promise.reject(error);
        }));

        promises.push(await axios.get('get_mainclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.mainClasses = resp.data.data.main_classes;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return Promise.reject(resp);
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return Promise.reject(error);
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      startAcquisition(classId, hasCategory, categoryId, subClassId) {
        const self = this;
        self.$router.push({ name: 'Acquisition', params: { classId: classId, hasCategory: hasCategory, categoryId: categoryId, subClassId: subClassId, redirectFrom: 'products' } });
      }
    }
  }
</script>
<style scoped>
.coming-soon-title {
  color: #3d9cbd;
  margin: .5rem auto 2.5rem;
  font-family: "Avenir Heavy";
  font-size: 2.313rem;
  /* font-weight: 900; */
  text-align: center;
}
.coming-soon-title span {
  color: #ef7c94;
}
</style>


// WEBPACK FOOTER //
// src/pages/ComingSoon.vue